<template>

  <v-text-field hide-details :readonly="true" :value="displayTimestamp"
    @click="proposeDate"
    >


      <template v-slot:append><v-btn prepend-icon="mdi-calendar" class="pa-4" size color="primary"
        :disabled="isFormReadOnly"
         @click="proposeDate"
        >

          <v-dialog v-model="dialogSelectDate"  width="auto" theme="dark">
            <v-card>
              <v-card-title>Seleziona data</v-card-title>
              <v-card-text>
                <v-container>
                  <v-row justify="space-around">
                    <v-text-field v-model="proposedDate" 
                        @update:modelValue="proposedDateUpdated()"
                        type="datetime-local" color="blue-darken-3"
                        :max="todayISOString"
                        :min="minDate"
                        >
                      <template #title>
                        seleziona data
                      </template>
                      <template v-slot:append>
                        <v-btn size="" class="pa-2" variant="elevated" color="orange-darken-3" @click="selectToday">
                          <template v-slot:prepend>
                            <v-icon>mdi-clock</v-icon>
                          </template>
                        </v-btn>
                      </template>
                    </v-text-field>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions class="flex-column">
                <v-btn size="large" variant="elevated" color="blue-darken-3" @click="setSelectedFromProposed">
                  <template v-slot:prepend>
                    <v-icon class="ml-2">mdi-check</v-icon>
                  </template>
                  Imposta
                </v-btn>
                <v-btn size="large" variant="outlined" color="white" @click="dialogSelectDate = false"
                    class="mx-0 my-3">

                  <template v-slot:prepend>
                    <v-icon class="ml-2">mdi-chevron-down</v-icon>
                  </template>
                  Indietro</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-btn>
      </template>
    </v-text-field>
</template>

<script setup>

import { ref, computed, onMounted,  inject } from "vue";


const isFormReadOnly = ref(false) 


const model = defineModel()

const dialogSelectDate = ref(false);

const selectedDate = ref(null)

const proposedDate = ref(null)


// 60 days ago
const minDate = computed(() => {
  const day_in_ms =  24 * 60 * 60 * 1000
  return new Date(Date.now() - 60 * day_in_ms).toISOString().split(".")[0]
  // return new Date(Date.parse('2024-01-01')).toLocaleDateString()
})


const today = computed(() => {
  return new Date(Date.now())
})


const todayISOString = computed(() => {
  // return new Date(today.value).toLocaleDateString().split(".")[0]
  const the_value = new Date(Date.now()).toISOString().split(".")[0]
  console.log(the_value)
  return the_value
})


const proposedDateUpdated = () => {
    console.log(new Date(proposedDate.value))
    console.log(todayISOString.value)
    console.log( new Date(todayISOString.value))
  if (new Date(proposedDate.value) > new Date(todayISOString.value)){
    proposedDate.value =  todayISOString.value
  }
  
  if (new Date(proposedDate.value) < new Date(minDate.value)){
    proposedDate.value =  minDate.value
  }
}

const proposeDate = () => {
  setProposedFromModel()
  dialogSelectDate.value=true

}


// const selectedDateIso = computed(() => {

// return new Date(selectedDate.value).toISOString().split(".")[0]

// })



const setSelectedFromProposed = () => {
  selectedDate.value = proposedDate.value
  model.value = new Date(selectedDate.value).valueOf()
  dialogSelectDate.value = false
}


const setProposedFromModel = () => {
  console.log("imposta proposed")
  const options = { timeZone: "Europe/Rome", hour12: false };
  proposedDate.value = new Date(model.value)
  .toLocaleString("sv-SE", options)
  .replace(" ", "T");
}


const selectToday = () => {
  console.log("imposta proposed");

  const timeZone = "Europe/Rome";
  const options = {
    timeZone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  };

  const formatter = new Intl.DateTimeFormat("sv-SE", options);
  const parts = formatter.formatToParts(new Date());

  // Build an ISO-like string
  const the_value = `${parts[0].value}-${parts[2].value}-${parts[4].value}T${parts[6].value}:${parts[8].value}:${parts[10].value}`;
  
  console.log(the_value);
  proposedDate.value = the_value;
  
}


const displayTimestamp = computed(() => {
  const timeZone = "Europe/Rome"
  return Intl.DateTimeFormat('it-IT', {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    timeZone: timeZone
      }).format(model.value);
})

onMounted(async () => {

  const svf = inject(Symbol.for("vuetify:form"), { isReadonly: false })
  isFormReadOnly.value = svf.isReadonly.value

  if (model.value) {
    // console.log("restore from timestamp")
    // console.log("leggo: " + model.value)
    selectedDate.value = new Date(new Date(model.value).toLocaleString("en-US", {timeZone: "Europe/Rome"})).toISOString().split(".")[0]
  }
  else {
    // console.log("new date ")
    // new Date(new Date(model.value).toLocaleString("en-US", {timeZone: "Europe/Rome"}))
    selectedDate.value = new Date(model.value).toLocaleString("en-US", {timeZone: "Europe/Rome"}).toISOString().split(".")[0]
    // selectedDate.value = new Date(new Date(model.value).toLocaleString("en-US", {timeZone: "Europe/Rome"})).toISOString().split(".")[0]
  }

  setProposedFromModel()

})

// watch(selectedDate, (newVal, oldVal) => {

const selectedDateChanged = () => {

  dialogSelectDate.value = false
// / watch(selectedDate, (newVal) => {
  // viene settato 00:00
  // mettiamo 12:00 di default
  const twelvehours = 12 * 60 * 60 * 1000
  // console.log(newVal)

  selectedDate.value.setTime(selectedDate.value.getTime() + twelvehours);

  model.value = selectedDate.value.valueOf()


  // console.log("scrivo: " + newVal.valueOf())
  // console.log("scrivo: " + model.value)

}


// console.log(model)

// console.log("controllare assegnazione uuid")



</script>
